import { useEffect, useState } from "react";
import { PracticeTabRow } from "components/molecules/PracticeTabRow";
import { DropDown } from "components/atoms";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { decodeToken } from "utils/functions/decodeToken";
import { LSAT_TEST_TYPE } from "utils/constants";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  isBtn?: boolean;
  isSecondBtn?: boolean;
  secondBtnLabel?: string;
  isMobile: boolean;
  isPractice?: boolean;
  tabNo?: number;
  data: any;
  label?: string;
  dropDownData?: string[];
}

export const TabPracticeContent = ({
  theme,
  isSecondBtn,
  secondBtnLabel,
  isBtn,
  isMobile,
  isPractice,
  tabNo,
  data,
  label,
  dropDownData,
}: IProps) => {
  const [secondDropDownValue, setSecondDropDownValue] = useState<
    null | string | { [key: number]: string }
  >("Select");
  const [dropDownValue, setDropDownValue] = useState("");

  const payload = decodeToken();

  const isLSATtest =
    payload &&
    payload.hasOwnProperty("testtype") &&
    payload.testtype === LSAT_TEST_TYPE;

  useEffect(() => {
    setDropDownValue("");
    setSecondDropDownValue("Select");
  }, [tabNo]);

  const getScores = (scores: any): string => {
    let score_1 = "";
    let score_2 = "";
    let score_3 = "";

    scores.map((item: any, index: number) => {
      if (item.Prefix === "") {
        if (score_1 === "") {
          score_1 = item.Score;
        } else if (score_2 === "") {
          score_2 = item.Score;
        } else {
          score_3 = item.Score;
        }
      } else {
        if (item.Prefix === "Verbal Reasoning") {
          if (score_1 === "") {
            score_1 = `V:${item.Score}`;
          } else if (score_2 === "") {
            score_2 = `V:${item.Score}`;
          } else {
            score_3 = `V:${item.Score}`;
          }
        }
        if (item.Prefix === "Quantitative Reasoning") {
          if (score_1 === "") {
            score_1 = `Q:${item.Score}`;
          } else if (score_2 === "") {
            score_2 = `Q:${item.Score}`;
          } else {
            score_3 = `Q:${item.Score}`;
          }
        }
        if (item.Prefix === "Issue Essay") {
          if (score_1 === "") {
            score_1 = `I:${item.Score}`;
          } else if (score_2 === "") {
            score_2 = `I:${item.Score}`;
          } else {
            score_3 = `I:${item.Score}`;
          }
        }
      }
    });
    const returnString = `${score_1}${score_2}${score_3}`;

    if (returnString === "") {
      return `${score_1}${score_2}${score_3}`;
    }

    const doubleSpace = score_1 && score_2 ? " | " : "";
    const singleSpace =
      score_1 && score_2 && score_3
        ? " | "
        : score_1 && score_2
        ? ""
        : score_1 && score_3
        ? " | "
        : score_1 && score_3
        ? " | "
        : "";

    return ` - Score: ${score_1}${doubleSpace}${score_2}${singleSpace}${score_3}`;
  };

  return (
    <div className="class-home-container">
      {label !== "Required Tests" && label !== "AAMC Tests" ? (
        <div className="tab-drop-down-section">
          <div className="drop-down-section">
            <DropDown
              data={dropDownData}
              setDropDownSelection={setSecondDropDownValue}
              defaultSelected={secondDropDownValue}
            />
          </div>

          {isLSATtest && secondDropDownValue ? (
            <>
              {data
                .filter((item: any) => {
                  if (secondDropDownValue === "Select") {
                    return item;
                  } else {
                    return (
                      item.ExamGroupName ===
                      Object.values(secondDropDownValue)[0]
                    );
                  }
                })
                .map((filterItem: any, index: any) => (
                  <PracticeTabRow
                    key={filterItem.Id ?? filterItem.ContentObjectId ?? index}
                    theme={theme}
                    index={index}
                    textIconLabel={filterItem.Name}
                    iconType={
                      filterItem.Status === "Lock" ||
                      filterItem.IsLocked === true
                        ? "lock"
                        : filterItem.Status === "Completed"
                          ? "select"
                          : filterItem.Status === "Pending"
                            ? "empty-circle"
                            : "yellow-timer"
                    }
                    btnLabel={
                      filterItem.Status === "Completed"
                        ? "Restart Test"
                        : filterItem.Status === "Pending"
                          ? "Start Test"
                          : "Resume"
                    }
                    middleLabel={
                      filterItem.Status === "Completed"
                        ? `Completed on ${formatToLocalDate(filterItem.DateCompleted, "MM/DD/YYYY")}${getScores(
                            filterItem.Scores
                          )}`
                        : filterItem.Status === "Pending"
                          ? "Not started"
                          : "In Progress"
                    }
                    isSecondBtn={
                      filterItem.Status === "Completed" &&
                      filterItem.ContentObjectType !== "AAMC"
                    }
                    secondBtnLabel="View Score Report"
                    isBtn={isBtn}
                    isMobile={isMobile}
                    primaryBtnLink={
                      filterItem.LaunchTests.length > 0
                        ? filterItem.LaunchTests[0].LaunchUrl
                        : ""
                    }
                    secondaryBtnLink={filterItem.ScoreReportUrl}
                    item={filterItem}
                    contentObjectType={filterItem.ContentObjectType}
                  />
                ))}
            </>
          ) : secondDropDownValue && dropDownValue ? (
            <>
              {data
                .filter((item: any) => item.ExamGroupName === dropDownValue)
                .map((filterItem: any, index: any) => (
                  <PracticeTabRow
                    key={filterItem.Id ?? filterItem.ContentObjectId ?? index}
                    theme={theme}
                    index={index}
                    textIconLabel={filterItem.Name}
                    iconType={
                      filterItem.Status === "Lock" ||
                      filterItem.IsLocked === true
                        ? "lock"
                        : filterItem.Status === "Completed"
                          ? "select"
                          : filterItem.Status === "Pending"
                            ? "empty-circle"
                            : "yellow-timer"
                    }
                    btnLabel={
                      filterItem.Status === "Completed"
                        ? "Restart Test"
                        : filterItem.Status === "Pending"
                          ? "Start Test"
                          : "Resume"
                    }
                    middleLabel={
                      filterItem.Status === "Completed"
                        ? `Completed on ${formatToLocalDate(filterItem.DateCompleted, "MM/DD/YYYY")}${getScores(
                            filterItem.Scores
                          )}`
                        : filterItem.Status === "Pending"
                          ? "Not started"
                          : "In Progress"
                    }
                    isSecondBtn={
                      filterItem.Status === "Completed" &&
                      filterItem.ContentObjectType !== "AAMC"
                    }
                    secondBtnLabel="View Score Report"
                    isBtn={isBtn}
                    isMobile={isMobile}
                    primaryBtnLink={
                      filterItem.LaunchTests.length > 0
                        ? filterItem.LaunchTests[0].LaunchUrl
                        : ""
                    }
                    secondaryBtnLink={filterItem.ScoreReportUrl}
                    item={filterItem}
                    contentObjectType={filterItem.ContentObjectType}
                  />
                ))}
            </>
          ) : (
            <div className="content-row-section">
              {data.map((item: any, index: any) => (
                <PracticeTabRow
                  key={item.Id ?? item.ContentObjectId ?? index}
                  theme={theme}
                  index={index}
                  textIconLabel={item.Name}
                  iconType={
                    item.Status === "Lock" || item.IsLocked === true
                      ? "lock"
                      : item.Status === "Completed"
                        ? "select"
                        : item.Status === "InProgress"
                          ? "yellow-timer"
                          : "empty-circle"
                  }
                  btnLabel={
                    item.Status === "Completed"
                      ? "Restart Test"
                      : item.Status === "InProgress"
                        ? "Resume"
                        : "Start Test"
                  }
                  middleLabel={
                    item.Status === "Completed"
                      ? `Completed on ${formatToLocalDate(item.DateCompleted, "MM/DD/YYYY")}${getScores(item.Scores)}`
                      : item.Status === "InProgress"
                        ? "In Progress"
                        : "Not started"
                  }
                  isSecondBtn={
                    item.Status === "Completed" &&
                    item.ContentObjectType !== "AAMC"
                  }
                  secondBtnLabel="View Score Report"
                  isBtn={isBtn}
                  isMobile={isMobile}
                  primaryBtnLink={
                    item.LaunchTests.length > 0
                      ? item.LaunchTests[0].LaunchUrl
                      : ""
                  }
                  secondaryBtnLink={item.ScoreReportUrl}
                  item={item}
                  contentObjectType={item.ContentObjectType}
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="content-row-section">
          {data.map((item: any, index: any) => (
            <PracticeTabRow
              key={item.Id ?? item.ContentObjectId ?? index}
              theme={theme}
              index={index}
              textIconLabel={item.Name}
              iconType={
                item.Status === "Lock" || item.IsLocked === true
                  ? "lock"
                  : item.Status === "Completed"
                    ? "select"
                    : item.Status === "InProgress"
                      ? "yellow-timer"
                      : "empty-circle"
              }
              btnLabel={
                item.ContentObjectType === "AAMC"
                  ? "Start Test"
                  : item.Status === "Completed"
                    ? "Restart Test"
                    : item.Status === "InProgress"
                      ? "Resume"
                      : "Start Test"
              }
              middleLabel={
                item.Status === "Completed"
                  ? `Completed on ${formatToLocalDate(item.DateCompleted, "MM/DD/YYYY")}${getScores(item.Scores)}`
                  : item.Status === "InProgress"
                    ? "In Progress"
                    : "Not started"
              }
              isSecondBtn={
                item.Status === "Completed" && item.ContentObjectType !== "AAMC"
              }
              secondBtnLabel="View Score Report"
              isBtn={isBtn}
              isMobile={isMobile}
              primaryBtnLink={
                item.LaunchTests.length > 0 ? item.LaunchTests[0].LaunchUrl : ""
              }
              secondaryBtnLink={item.ScoreReportUrl}
              item={item}
              contentObjectType={item.ContentObjectType}
            />
          ))}
        </div>
      )}
    </div>
  );
};
